import { Component } from '@angular/core';

@Component({
  selector: 'app-vehicletype-list',
  templateUrl: './vehicletype-list.component.html',
  styleUrls: ['./vehicletype-list.component.css']
})
export class VehicletypeListComponent {

}
